import { observable, action, decorate } from 'mobx';
import PressArticleService from '../services/PressArticle.service';

const DEFAULT_ARTICLES_LIMIT = 10;

class PressArticleStore {
  searches = new Map();

  async fetchArticles(criteria) {
    const { limit = DEFAULT_ARTICLES_LIMIT, page = 1, category } = criteria;

    const cacheKey = JSON.stringify({
      category,
      page,
      limit
    });

    const cachedSearch = this.searches.get(cacheKey);

    if (cachedSearch) {
      return cachedSearch;
    }

    try {
      const items = await PressArticleService.fetchPressArticles({
        limit,
        page,
        category
      });

      if (items.isEmpty) {
        return {
          isExploited: true,
          data: []
        };
      }

      const isNextPage = !!items.pagination.nextPage;

      const data = {
        isExploited: !isNextPage,
        data: items.items
      };

      this.searches.set(cacheKey, data);

      return data;
    } catch (e) {
      console.error('Failed to fetch featured press articles data', e);
      return null;
    }
  }
}

decorate(PressArticleStore, {
  searches: observable,
  fetchArticles: action
});

export default new PressArticleStore();



// WEBPACK FOOTER //
// ./src/stores/PressArticle.store.js